import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home } from "lucide-react";
import { useAuth } from "../../../context/AuthContext";

const HomeLink: React.FC = () => {
  const location = useLocation();
  const { user } = useAuth();

  const roleName = user?.role?.nome?.toLowerCase() || "";
  const isPizzaiolo = roleName === "pizzaiolo";
  const isEntregador = roleName === "entregadores" || roleName === "entregador";
  const isRoterista = roleName === "roterista";
  const isBordeiro = roleName === "bordeiro";

  let homePath = "/dashboard";
  if (isPizzaiolo) {
    homePath = "/pizzaiolo-integracao";
  } else if (isEntregador) {
    homePath = "/entregadores";
  } else if (isRoterista) {
    homePath = "/roterista-automatico";
  } else if (isBordeiro) {
    homePath = "/bordeiro";
  }

  if (location.pathname === homePath) {
    return null;
  }

  return (
    <li>
      <Link
        to={homePath}
        className="flex items-center gap-2 text-neutral-500 hover:text-neutral-700"
      >
        <Home size={16} />
        <span>Início</span>
      </Link>
    </li>
  );
};

export default HomeLink;
